import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {IHolidayCalendarStoreData, IHolidayCalendarData} from './types';
import {AppState} from '../../../../verticals/hotels-dweb/src/shared/store';
import {updateHolidayCalendarDataAction} from './actions';
import {getHolidayCalendarApi} from '@stencil/holiday-calendar-api/src/holiday-calendar-api';

export const getHolidayCalendarDataThunk = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    getHolidayCalendarApi()
      .then((response: IHolidayCalendarStoreData) => {
        if (response?.success && response?.data && response?.data?.calendar_json) {
          dispatch(
            updateHolidayCalendarDataAction(response.data.calendar_json as IHolidayCalendarData),
          );
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};
